// Function to get location details using latitude and longitude
// export async function getLocationDetails(latitude, longitude) {
//     const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`;
//
//     try {
//         const response = await fetch(url);
//         const data = await response.json();
//
//         // Extracting the required fields
//         const address = data.display_name;
//         const city = data.address.city || data.address.town || data.address.village;
//         const state = data.address.state;
//         const country = data.address.country;
//         const pincode = data.address.postcode;
//
//         // Returning the desired information
//         return {
//             address: address,
//             city: city,
//             state: state,
//             country: country,
//             pincode: pincode
//         };
//     } catch (error) {
//         console.error('Error fetching location:', error);
//         return null;
//     }
// }

import dayjs from "dayjs";
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import relativeTime from "dayjs/plugin/relativeTime";
import pdf from "../../public/Images/pdf.png";
import doc from "../../public/Images/doc.png";
import txt from "../../public/Images/txt.png";
import pptx from "../../public/Images/pptx.png";
import default_file from "../../public/Images/default_file.png";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { getUserDataFromStore } from "@/Redux/store/store";
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrBefore);

const returnFiles = {
  'pdf': pdf,
  'doc': doc,
  'txt': txt,
  'pptx': pptx,
  'default_file': default_file,
}
const convertUTCToUserTimezone = (utcDate, userTimezone) => {
  return utcDate ? dayjs(utcDate).tz(userTimezone).toDate() : null;
};
const getExtensionImage = (fileName) => {

  const split = fileName?.split('/');
  const name = split?.pop();
  const nameSplit = name?.split('.');
  const type = nameSplit?.pop();

  return returnFiles[type] || default_file;

}

const timeAgo = (date) => {
  dayjs.extend(relativeTime);
  return dayjs(date).fromNow();
};

const convertTo24HourFormat = (dateTime) => {
  const userData = getUserDataFromStore();
  return dayjs(dateTime).tz(userData.timezone).format('MMM D, YYYY hh:mm A');
};

const convertTo24HourWithDateFormat = (dateTime) => {
  const userData = getUserDataFromStore();
  return dayjs(dateTime).tz(userData.timezone).format('MMM D, h:mm A');
};

// '2024-09-15T18:30:00.000Z' to  "15 Sep"
const convertToMonthAndDayWithDateFormat = (dateTime) => {
  const userData = getUserDataFromStore();
  return dayjs(dateTime).tz(userData.timezone).format('DD MMM');
};

const convertToMonthAndDayWithDateFormatWithYear = (dateTime) => {
  const userData = getUserDataFromStore();
  return dayjs(dateTime).tz(userData.timezone).format('DD MMM, YYYY');
};

// '2024-09-15T18:30:00.000Z' to  "06:30 PM"
const convertTimeTo24HourWithDateFormat = (startTime) => {
  const userData = getUserDataFromStore();
  let localDateTime;
  if (startTime?.includes('T')) {
    localDateTime = dayjs(startTime).tz(userData.timezone);
  } else {
    localDateTime = dayjs(`1970-01-01T${startTime}`);
  }
  return localDateTime.format('hh:mm A');
};

function calculateDurationInReadableFormat(dateTime1, dateTime2) {
  // Parse the ISO date-time strings into Date objects
  const date1 = new Date(dateTime1);
  const date2 = new Date(dateTime2);

  // Calculate the absolute difference in milliseconds
  const diffInMilliseconds = Math.abs(date2 - date1);

  // Convert the difference to hours and minutes
  const totalMinutes = Math.floor(diffInMilliseconds / (1000 * 60));
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  // Construct the readable format
  let result = '';
  if (hours > 0) {
    result += `${hours} hour${hours > 1 ? 's' : ''}`; // Adds "s" for plural hours
  }
  if (minutes > 0) {
    if (hours > 0) {
      result += ' ';
    }
    result += `${minutes} minute${minutes > 1 ? 's' : ''}`; // Adds "s" for plural minutes
  }

  // If neither hours nor minutes, return 0 minutes
  if (!result) {
    result = '0 minutes';
  }

  return result;
}

const convertDateToYearFormat = (dateTime) => {
  const userData = getUserDataFromStore();
  return dayjs(dateTime).tz(userData.timezone).format('MMM D, YYYY');
};

const getFileTypeFromUrl = (fileUrl) => {
  const imageExtensions = ['jpg', 'jpeg', 'png'];
  const fileExtension = fileUrl.split('.').pop().toLowerCase();
  return imageExtensions.includes(fileExtension) ? 'image' : 'file';
};
const getUnreadMessageCount = (count1, count2) => {
  let totalCount = 0;
  if (count1) {
    totalCount += count1;
  }
  if (count2) {
    totalCount += count2;
  }
  return totalCount;
}
function calendarDateFormat(date) {
  const userData = getUserDataFromStore();
  return dayjs(date).tz(userData.timezone).format('YYYY-MM-DD');
}

function calendarDateFormatInString(date) {
  const userData = getUserDataFromStore();
  return dayjs(date).tz(userData.timezone).toDate();
}
function matchDates(date1, date2) {
  const jsDate1 = dayjs(date1);
  const jsDate2 = dayjs(date2);
  return jsDate1.isSame(jsDate2, 'day');
}
function dayJsDate(date) {
  const userData = getUserDataFromStore();
  return date ? dayjs(date).tz(userData.timezone) : dayjs().tz(userData.timezone)
}
function getCurrentSystemTimezone() {
  return dayjs.tz.guess();
}
const isValidTimezone = (tz) => {
  try {
    const supportedTimeZones = Intl.supportedValuesOf("timeZone");
    return supportedTimeZones.includes(tz);
  } catch (error) {
    return false;
  }
};
const listTimezone = () => {
  try {
    const supportedTimeZones = Intl.supportedValuesOf("timeZone");
    return supportedTimeZones;
  } catch (error) {
    return [];
  }
};
// Function to convert date from one timezone to another
function convertTimeZoneOfDate(dateStr, toZone, fromZone) {
  let date = dayjs(dateStr);
  if (fromZone) {
    date = dayjs.tz(dateStr, fromZone);
  }
  const dateInToZone = date.tz(toZone);
  return dateInToZone;
}

const convertDateTimeToUTC = (date, time) => {
  const userData = getUserDataFromStore();
  if (time?.includes('T')) {
    return time
  }
  const dateTime = dayjs.tz(`${date} ${time}`, userData.timezone)
  return dayjs(dateTime).utc().format(); // ISO string in UTC
};
const convertDateToUTC = (date) => {
  const userData = getUserDataFromStore();
  const dateTime = dayjs.tz(`${date}`, userData.timezone)
  return dayjs(dateTime).utc().format(); // ISO string in UTC
};

const getBackgroundColor = (letter) => {
  const colors = {
    A: "bg-red-500",
    B: "bg-blue-500",
    C: "bg-green-500",
    D: "bg-yellow-500",
    E: "bg-indigo-500",
    F: "bg-purple-500",
    G: "bg-pink-500",
    H: "bg-orange-500",
    I: "bg-teal-500",
    J: "bg-cyan-500",
    K: "bg-lime-500",
    L: "bg-amber-500",
    M: "bg-rose-500",
    N: "bg-fuchsia-500",
    O: "bg-violet-500",
    P: "bg-blue-700",
    Q: "bg-green-700",
    R: "bg-yellow-700",
    S: "bg-indigo-700",
    T: "bg-purple-700",
    U: "bg-pink-700",
    V: "bg-orange-700",
    W: "bg-teal-700",
    X: "bg-cyan-700",
    Y: "bg-lime-700",
    Z: "bg-amber-700",
  };

  return colors[letter?.toUpperCase()] || "bg-gray-500";
};

function getDayOfWeek(dateInput) {
  const dayjsDate = dayjs(dateInput)
  return dayjsDate.toDate().getDay(); // 0 for Sunday, 1 for Monday, etc.
}

const convertTimeSlotsWithDayAdjustment = (schedule, fromTimezone, toTimezone) => {
  const convertedSchedule = {};
  const referenceDate = '2024-01-01'; // Use a reference date

  // Helper to add slots to a specific day
  function addSlotToDay(day, slot) {
    if (!convertedSchedule[day]) {
      convertedSchedule[day] = [];
    }
    convertedSchedule[day].push(slot);
  }

  function dayNumber(day) {
    if (day > 6) {
      day = day - 7;
    }
    if (day < 0) {
      day = day + 7;
    }
    return day;
  }

  Object.keys(schedule).forEach((day) => {
    const slots = schedule[day];
    slots.forEach((slot) => {
      const start = dayjs.tz(`${referenceDate} ${slot.startTime}`, 'HH:mm', fromTimezone);
      const end = dayjs.tz(`${referenceDate} ${slot.endTime}`, 'HH:mm', fromTimezone);
      const convertedStart = start.tz(toTimezone);
      const convertedEnd = end.tz(toTimezone);

      // Detect if the slot crosses to another day after conversion
      const convertedStartDay = dayjs(convertedStart).tz(toTimezone).day();
      const convertedEndDay = dayjs(convertedEnd).tz(toTimezone).day();
      const startDayOffset = convertedStartDay - 1;
      const endDayOffset = convertedEndDay - 1;

      const newStartTime = convertedStart.format('HH:mm');
      const newEndTime = convertedEnd.format('HH:mm');

      // Add to the proper day based on the offset
      let newStartDay = dayNumber(parseInt(day) + startDayOffset);
      let newEndDay = dayNumber(parseInt(day) + endDayOffset);

      if (newStartDay === newEndDay) {
        addSlotToDay(newStartDay, { startTime: newStartTime, endTime: newEndTime });
      } else {
        // Split the slot across days
        addSlotToDay(newStartDay, { startTime: newStartTime, endTime: "24:00" });
        addSlotToDay(newEndDay, { startTime: "00:00", endTime: newEndTime });
      }
    });
  });

  return convertedSchedule;
}

const convertTimeSlotsToUserTimezone = (slotDuration, availableTimes, userTimezone, timeslotTimezone) => {
  let duration = parseInt(slotDuration);
  const timeSlots = [];
  const timeSet = new Set(); // To track unique time slots

  function timeToMinutes(time) {
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
  }

  function minutesToTime(minutes) {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
  }

  let count = 1;

  availableTimes.forEach(({ startTime, endTime }) => {
    let start = timeToMinutes(startTime);
    let end = timeToMinutes(endTime);

    while (start + duration <= end) {
      const slotEnd = start + duration;
      const slotStartTime = minutesToTime(start);

      // Check if the slot is already in the set
      if (!timeSet.has(slotStartTime)) {
        timeSlots.push({
          id: count,
          startTime: slotStartTime,
          endTime: minutesToTime(slotEnd),
        });
        timeSet.add(slotStartTime); // Add startTime to the set to track uniqueness
        count++;
      }

      start = slotEnd;
    }
  });

  return timeSlots;
};

// const convertAndSplitSchedule = (schedule, fromTimezone, toTimezone, durationInMinutes) => {
//   const newSchedule = {
//     "0": [], "1": [], "2": [], "3": [], "4": [], "5": [], "6": []
//   };
//
//   Object.keys(schedule).forEach(day => {
//     const slots = schedule[day];
//
//     slots.forEach(slot => {
//       // Create a valid date object by combining today's date with the time string
//       let currentDate = dayjs().format('YYYY-MM-DD');
//       let startTimeInFromZone = dayjs.tz(`${currentDate} ${slot.startTime}`, 'YYYY-MM-DD HH:mm', fromTimezone);
//       let endTimeInFromZone = dayjs.tz(`${currentDate} ${slot.endTime}`, 'YYYY-MM-DD HH:mm', fromTimezone);
//
//       // Convert the startTime and endTime to the target timezone
//       let startTimeInToZone = startTimeInFromZone.tz(toTimezone);
//       let endTimeInToZone = endTimeInFromZone.tz(toTimezone);
//
//       // If the new startTime is on the previous day, adjust the day
//       let adjustedDay = day;
//       if (startTimeInToZone.day() !== dayjs().day()) {
//         adjustedDay = (parseInt(day) - 1 + 7) % 7; // Move to the previous day (adjusting for wrap-around to Saturday/Sunday)
//       }
//
//       // Calculate the total duration between startTime and endTime in minutes
//       let totalDuration = endTimeInToZone.diff(startTimeInToZone, 'minute');
//
//       // If the total duration is greater than the provided duration, split it
//       while (totalDuration >= durationInMinutes) {
//         let newEndTime = startTimeInToZone.add(durationInMinutes, 'minute');
//
//         // Add the new time slot to the schedule
//         newSchedule[adjustedDay].push({
//           startTime: startTimeInToZone.format('HH:mm'),
//           endTime: newEndTime.format('HH:mm')
//         });
//
//         // Move the startTime forward for the next slot
//         startTimeInToZone = newEndTime;
//         totalDuration -= durationInMinutes;
//       }
//     });
//   });
//
//   return newSchedule;
// };

const convertAndSplitSchedule = (schedule, fromTimezone, toTimezone, durationInMinutes) => {
  const durationInMinutesConv = Number(durationInMinutes) || 30;

  if (!schedule || typeof schedule !== 'object') {
    console.warn('Invalid schedule provided.');
    return null;
  }

  if (!fromTimezone || !toTimezone) {
    console.warn('Invalid timezones provided.');
    return null;
  }

  if (durationInMinutesConv <= 0) {
    console.warn('Duration must be a positive number.');
    return null;
  }

  const newSchedule = {
    today: [],
    otherDays: { "0": [], "1": [], "2": [], "3": [], "4": [], "5": [], "6": [] }
  };

  const nowInToZone = dayjs().tz(toTimezone);
  const currentDayInToZone = nowInToZone.day();
  const currentDateInToZone = nowInToZone.format('YYYY-MM-DD');

  Object.keys(schedule).forEach(day => {
    const slots = schedule[day];
    const dayInt = parseInt(day, 10);

    if (isNaN(dayInt) || dayInt < 0 || dayInt > 6) {
      console.warn(`Invalid day key: ${day}`);
      return;
    }

    let diff = dayInt - currentDayInToZone;
    if (diff < 0) diff += 7;

    const slotDate = nowInToZone.clone().add(diff, 'day').format('YYYY-MM-DD');

    if (!Array.isArray(slots)) {
      console.warn(`No slots found for day ${day}`);
      return;
    }

    slots.forEach(slot => {
      if (!slot.startTime || !slot.endTime) {
        console.warn(`Invalid slot format:`, slot);
        return;
      }

      const startTimeInFromZone = dayjs.tz(`${slotDate} ${slot.startTime}`, 'YYYY-MM-DD HH:mm', fromTimezone);
      const endTimeInFromZone = dayjs.tz(`${slotDate} ${slot.endTime}`, 'YYYY-MM-DD HH:mm', fromTimezone);

      if (!startTimeInFromZone.isValid() || !endTimeInFromZone.isValid()) {
        console.warn(`Invalid times for slot:`, slot);
        return;
      }

      const startTimeInToZone = startTimeInFromZone.clone().tz(toTimezone);
      const endTimeInToZone = endTimeInFromZone.clone().tz(toTimezone);

      let totalDuration = endTimeInToZone.diff(startTimeInToZone, 'minute');
      if (totalDuration <= 0) {
        console.warn(`End time must be after start time:`, slot);
        return;
      }

      let currentStart = startTimeInToZone.clone();

      while (totalDuration >= durationInMinutesConv) {
        const newEndTime = currentStart.clone().add(durationInMinutesConv, 'minute');
        const isToday = slotDate === currentDateInToZone && dayInt === currentDayInToZone;

        const newSlot = {
          startTime: currentStart.format('HH:mm'),
          endTime: newEndTime.format('HH:mm'),
        };

        if (isToday && currentStart.isAfter(nowInToZone)) {
          newSchedule.today.push(newSlot);
        }

        newSchedule.otherDays[day].push(newSlot);
        currentStart = newEndTime;
        totalDuration -= durationInMinutesConv;
      }
    });
  });

  return newSchedule;
};



export {
  convertToMonthAndDayWithDateFormatWithYear,
  convertAndSplitSchedule,
  getDayOfWeek,
  convertTo24HourFormat,
  timeAgo,
  convertToMonthAndDayWithDateFormat,
  convertTimeTo24HourWithDateFormat,
  calculateDurationInReadableFormat,
  getUnreadMessageCount,
  getFileTypeFromUrl,
  getExtensionImage,
  convertTo24HourWithDateFormat,
  calendarDateFormat,
  convertDateToYearFormat,
  matchDates,
  dayJsDate,
  getCurrentSystemTimezone,
  isValidTimezone,
  convertTimeZoneOfDate,
  listTimezone,
  convertDateTimeToUTC,
  convertDateToUTC,
  getBackgroundColor,
  convertTimeSlotsWithDayAdjustment,
  convertTimeSlotsToUserTimezone,
  convertUTCToUserTimezone,
  calendarDateFormatInString
}

export const formatProductList = (products, count = 2) => {
  const firstProducts = products.slice(0, count);
  const remainingProductsCount = products.length - firstProducts.length;
  return { firstProducts, remainingProductsCount };
};
export function debounce(func, delay) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func(...args);
    }, delay);
  };
}

export function generateAppointmentTimeSlots(duration, availableTimes, date, timezone) {
  duration = parseInt(duration);
  const userData = getUserDataFromStore();
  const timeSlots = [];
  const timeSet = new Set();  // To track unique time slots

  function timeToMinutes(time) {
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
  }

  function minutesToTime(minutes) {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
  }

  const now = dayjs().tz(userData.timezone); // Current time in the user's timezone
  const isToday = dayjs(date).isSame(now, 'day');
  const currentMinutes = now.hour() * 60 + now.minute();
  let count = 1;

  availableTimes.forEach(({ startTime, endTime }) => {
    // Convert start and end times to the given timezone without altering the date
    const startInTimezone = dayjs.tz(`${dayjs(date).format('YYYY-MM-DD')} ${startTime}`, timezone);
    const endInTimezone = dayjs.tz(`${dayjs(date).format('YYYY-MM-DD')} ${endTime}`, timezone);

    // Convert them back to the local timezone (keeping the date intact)
    const startInCurrentTimezone = startInTimezone.tz(userData.timezone ?? dayjs.tz.guess());
    const endInCurrentTimezone = endInTimezone.tz(userData.timezone ?? dayjs.tz.guess());
    let start = timeToMinutes(startInCurrentTimezone.format('HH:mm'));
    let end = timeToMinutes(endInCurrentTimezone.format('HH:mm'));

    const startDate = startInCurrentTimezone.format('YYYY-MM-DD');
    const endDate = endInCurrentTimezone.format('YYYY-MM-DD');

    if (startDate !== endDate) {
      end = 24 * 60;
    }
    // If today, skip time slots earlier than the current time
    if (isToday && start < currentMinutes) {
      start = currentMinutes;
    }
    while (start + duration <= end) {
      const slotEnd = start + duration;
      const slotStartTime = minutesToTime(start);

      // Check if the slot is already in the set
      if (!timeSet.has(slotStartTime)) {
        timeSlots.push({
          id: count,
          startTime: slotStartTime,
          endTime: minutesToTime(slotEnd),
        });
        timeSet.add(slotStartTime);  // Add startTime to the set to track uniqueness
        count++;
      }

      start = slotEnd;
    }
  });

  return timeSlots;
}

export const filterAvailableSlots = (timeSlots, appointments) => {
  // Convert appointment times to local time slots for comparison
  const bookedSlots = appointments.data.map(appointment => {
    const startTime = new Date(appointment.startTime);
    // Convert to HH:mm format in local timezone
    return {
      startTime: startTime.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      })
    };
  });

  // Filter out booked slots
  return timeSlots.filter(slot => {
    // Convert slot time to 24-hour format for comparison
    const [hours, minutes] = slot.startTime.split(':');
    const formattedSlotTime = `${hours.padStart(2, '0')}:${minutes}`;

    // Check if this slot is not in bookedSlots
    return !bookedSlots.some(bookedSlot => {
      return bookedSlot.startTime === formattedSlotTime;
    });
  });
};

export const filterAvailableSlotsWithException = (timeSlots, appointments, exceptionSlot = '') => {
  // Parse exception slot if provided
  let exceptionStartTime = '';
  if (exceptionSlot) {
    // Extract start time from format "09:30 AM - 10:00 AM"
    const timeMatch = exceptionSlot.match(/(\d{2}:\d{2}) [AP]M/);
    if (timeMatch) {
      // Convert to 24-hour format for comparison
      const [hours, minutes] = timeMatch[1].split(':');
      const isPM = exceptionSlot.includes('PM');
      let hour24 = parseInt(hours);

      if (isPM && hour24 !== 12) {
        hour24 += 12;
      } else if (!isPM && hour24 === 12) {
        hour24 = 0;
      }

      exceptionStartTime = `${hour24.toString().padStart(2, '0')}:${minutes}`;
    }
  }

  // Convert appointment times to local time slots for comparison
  const bookedSlots = appointments.data.map(appointment => {
    const startTime = new Date(appointment.startTime);
    // Convert to HH:mm format in local timezone
    return {
      startTime: startTime.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      })
    };
  });

  // Filter out booked slots, but keep exception slot
  return timeSlots.filter(slot => {
    // Convert slot time to 24-hour format for comparison
    const [hours, minutes] = slot.startTime.split(':');
    const formattedSlotTime = `${hours.padStart(2, '0')}:${minutes}`;

    // If this slot matches the exception slot, always include it
    if (formattedSlotTime === exceptionStartTime) {
      return true;
    }

    // Check if this slot is not in bookedSlots
    return !bookedSlots.some(bookedSlot => {
      return bookedSlot.startTime === formattedSlotTime;
    });
  });
};

/**
 * Safely access user data from Redux state
 * @param {Object} state - Redux state object
 * @returns {Object|null} - User object or null if not available
 */
export const getSafeUserData = (state) => {
  try {
    return state?.userData?.userData?.user || null;
  } catch (error) {
    console.warn('Error accessing user state:', error);
    return null;
  }
};

/**
 * Safely remove a DOM element to prevent removeChild errors
 * @param {HTMLElement} element - The element to remove
 * @param {HTMLElement} parent - The parent element (optional, will be detected if not provided)
 */
export const safeRemoveElement = (element, parent = null) => {
  try {
    if (!element) return;
    
    const parentElement = parent || element.parentNode;
    if (parentElement && parentElement.contains(element)) {
      parentElement.removeChild(element);
    }
  } catch (error) {
    console.warn('Error removing DOM element:', error);
  }
};

/**
 * Safely add event listener with cleanup
 * @param {HTMLElement} element - The element to add listener to
 * @param {string} event - The event type
 * @param {Function} handler - The event handler
 * @returns {Function} - Cleanup function to remove the listener
 */
export const safeAddEventListener = (element, event, handler) => {
  try {
    if (!element) return () => {};
    
    element.addEventListener(event, handler);
    return () => {
      try {
        element.removeEventListener(event, handler);
      } catch (error) {
        console.warn('Error removing event listener:', error);
      }
    };
  } catch (error) {
    console.warn('Error adding event listener:', error);
    return () => {};
  }
};

/**
 * Safely check if element exists in DOM
 * @param {HTMLElement} element - The element to check
 * @returns {boolean} - True if element exists and is in DOM
 */
export const isElementInDOM = (element) => {
  try {
    return element && document.contains(element);
  } catch (error) {
    console.warn('Error checking if element is in DOM:', error);
    return false;
  }
};